<script setup>
import { ref, inject, onMounted, watch } from 'vue';
import Dialog from 'primevue/dialog';
import { 
	apiGetDernieresCommandes,
    apiOublierDernieresCommandes } from '@/services/ServiceModele.js';

const visible = defineModel('visible', {
    type: Boolean
});

const appelerApiModele = inject('appelerApiModele');

const dernieresCommandes = ref([]);
const nbCommandesAAnnuler = ref(1);

onMounted(() => {
    if (visible.value) {
        chargerDernieresCommandes();
    }
});

watch(() => visible.value, (visible) => {
    if (visible) {
        chargerDernieresCommandes();
        nbCommandesAAnnuler.value = 1;
    }
});

function chargerDernieresCommandes() {
    appelerApiModele(apiGetDernieresCommandes, [], function(reponseOK, resultat) {
        if (reponseOK) {
            dernieresCommandes.value = resultat;
        }
    });
}

function valider() {
    appelerApiModele(apiOublierDernieresCommandes, [nbCommandesAAnnuler.value], (reponseOK) => {
        if (reponseOK) {
            visible.value = false;
            window.location.reload();
        }
    });
}

</script>

<template>
    <Dialog 
    v-model:visible="visible"
    :modal="true">
        <template #header>
            <label class="titre">Dernières commandes</label>
        </template>
        <div class="corps-modale">
            <label>Nombre de commandes à annuler :</label>
            <input type="number" min="1" :max="dernieresCommandes.length - 1" v-model="nbCommandesAAnnuler"/>
            <span v-for="(commande, indice) in dernieresCommandes">{{ `${indice + 1} - ${commande}` }}</span>
        </div>
        <template #footer>
            <button 
                class="bouton btn-primaire fas fa-check" 
                :disabled="nbCommandesAAnnuler <= 0 || nbCommandesAAnnuler >= dernieresCommandes.length"
                @click="valider()"/>
        </template>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

.corps-modale {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 50vw;
    height: 90vh;
}
</style>
